// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20G0y","buttons":"styles_buttons__akdF7"};